export const environment = {
  production: true,
  cookieDomain: 'data.faang.org',
  envName: 'prod',
  host: 'https://api.faang.org/',
  relatedProjectsHost: 'https://raw.githubusercontent.com/FAANG/comm-data-portal-projects/master/projects/'
};
